class UnauthorizedException
{
    private readonly _text: string;
    
    constructor(text: string) 
    {
        this._text = text;
    }
}

class SiteContainerRequestCommand
{
    private _container: ISiteContainer;
    private _card: ISiteCard;
    private _request: ISiteRequest;
    private _site: Site;

    constructor(site: Site, container: ISiteContainer, card: ISiteCard, request: ISiteRequest)
    {
        this._site = site;
        this._container = container;
        this._card = card;
        this._request = request;
    }

    async execute()
    {
        // -- Do a request
        let queryRequest = await new QueryRequest(
            SiteAction.toLink(this._request.request),
            this._request.model ?
                {
                    contentType: 'json',
                    data: this._request.model,
                    method: 'post'
                }
                : {
                    contentType: 'json',
                    method: 'get'
                }
            ).request();
        
        if (queryRequest.status == 401)
            throw new UnauthorizedException(await queryRequest.text());
        
        let json = await queryRequest.json() as ISiteResponse;

        return await this.handle(json);
    }

    private async handle(json: ISiteResponse)
    {
        switch (json.type) {
            case "Multi":
                let multiAction = json as ISiteResponseMultiAction;
                for (let action of multiAction.actions) {
                    if (!await this.handle(action))
                        return false;
                }

                return true;
            case "Card":
                let response = json as ISiteResponseCard;
                // -- Request the view
                let view = await SiteContainer.getCardView(response.view);
                let createdCard = new SiteCard(this._container, view, response, this._request);
                if(this._request.options && this._request.options.override == true) {
                    await this._container.replaceCard(this._card, createdCard);
                } else {
                    await this._container.removeNextCards(this._card);
                    await this._container.appendCard(createdCard);
                    await this._container.makeCardActive(createdCard);
                }

                return true;
            case "CardAction":
                let cardAction = json as ISiteResponseCardAction;
                let action = SiteAction.create(this._card, cardAction.action);
                action && action.execute();
                
                return true;
            case "Redirect":
                let redirectResponse = json as ISiteResponseRedirect;
                let requestInfo : ISiteRequest = {
                    request: redirectResponse.action.actionInfo,
                    model: JSON.stringify(redirectResponse.action.model)
                };

                return await this._container.request(this._card, requestInfo);
            case "Validation":
                let valitationResponse = json as ISiteResponseValidation;
                this._site.addMessage(new SiteMessage({
                    title: "Fout opgetreden bij opslaan",
                    message: valitationResponse.message,
                    sort: "Error"
                }));
                // For now clear and addValidation
                this._card.clearValidation();
                this._card.addValidation(this._request.path || [], valitationResponse);
                return false;
            case "Modal":
                let modal = json as ISiteResponseModal;
                this._site.showModal(this._card, modal.modal);
                return true;
            case "Message":
                let responseMessage = json as ISiteResponseMessage;

                if (responseMessage.affectedTypes && responseMessage.affectedTypes.length > 0) {
                    let changeEvent = new ObserverChangeEvent(
                        this._request.request.id, responseMessage.affectedTypes);

                    this._site.trigger("qts.observer.change", false, changeEvent);
                }

                let message = new SiteMessage(responseMessage);
                this._site.addMessage(message);
                return true;
        }
    }
}